module.exports = __webpack_public_path__ + "img/chase_slide_2.7d284b14.jpg";